// أعلام الميزات — فعّل/عطّل ميزات كاملة من مكان واحد
// المتاجر الشريكة (Marketplace): معطلة مؤقتاً بقرار المالك — أعد التفعيل بجعلها true
export const MARKETPLACE_ENABLED = false;
